module.exports = __webpack_public_path__ + "img/total_guest.cb232a08.webp";